import React, { useState, Component, useRef } from 'react';
import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import authService from '../api-authorization/AuthorizeService'
import debounce from 'lodash.debounce';


export class BarcosView extends Component {
    constructor(props) {
        super(props);
        var rawUrl = window.location.toString();
        var naviera_Id = rawUrl.split("Navieras/")[1].split("/")[0];
        this.state = {
            operation: props.operation,
            paises: [],
            puertos: []
        };
        if (props.data) {
            this.state.model = props.data
        }
        else {
            this.state.model = {naviera_Id: naviera_Id, pais_Id: 0, puerto_Id: 0, nombre: "" };
        }
        console.log(" this.state.model", this.state.model)
        this.state.modelValidation = {
            nombre: this.state.model.nombre != "",
            pais_Id: this.state.model.pais_Id != 0,
            puerto_Id: this.state.model.puerto_Id != 0,
        }
        this.handleChange = this.handleChange.bind(this);
        this.load_paises = this.load_paises.bind(this);
        this.load_puertos = this.load_puertos.bind(this);
        this.validate = this.validate.bind(this);
        this.validate = debounce(this.validate, 1000)
    }

    handleChange(event) {

        var tempModel = this.state.model;
        tempModel[event.target.name] = event.target.value;
        this.setState({
            model: tempModel
        }, async () => {
            if (event.target.name == "pais_Id") {
                this.setState({
                    puertos: await this.load_puertos()
                });
            }
            this.props.setModalBodyState(this.state).then(() => this.validate());
        });
        
    }
    async validate() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.state.model);
        const response = await fetch('api/barcos/validate', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            var validations = await response.json();
            this.setState({
                modelValidation: validations
            }, () => {
                this.props.setModalBodyState(this.state);
            });
        }
    }
    getValidationValue(value) {
        if (value == null || value == undefined) {
            return true;
        }
        else {
            return value;
        }
    }
    
    render() {
        return (
            <div >
                <Row>
                    <Form>
                        <Row>
                            <FormGroup>
                                <Label for="Nombre">
                                    <FormattedMessage id='Nombre' />
                                </Label>
                                <FormattedMessage id='Nombre'>
                                    {(placeholder) =>
                                        <Input
                                            id="nombre"
                                            name="nombre"
                                            placeholder={placeholder}
                                            type="text"
                                            onChange={this.handleChange}
                                            value={this.state.model.nombre}
                                            valid={this.getValidationValue(this.state.modelValidation.nombre)}
                                            invalid={!this.getValidationValue(this.state.modelValidation.nombre)}
                                        />
                                    }
                                </FormattedMessage>
                                <FormFeedback>
                                    {this.state.model.nombre == '' ? <FormattedMessage id='Este campo es requerido' /> : <FormattedMessage id='Este nombre ya esta siendo usado' />}
                                </FormFeedback>
                                </FormGroup>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label for="pais_Id">
                                        <FormattedMessage id='Pais' />
                                    </Label>
                                    <Input
                                        id="pais_Id"
                                        name="pais_Id"
                                        type="select"
                                        onChange={this.handleChange}
                                        value={this.state.model.pais_Id}
                                        valid={this.getValidationValue(this.state.modelValidation.pais_Id)}
                                        invalid={!this.getValidationValue(this.state.modelValidation.pais_Id)}
                                    >
                                        <option value="0"></option>
                                        {this.state.paises.map(pais => pais.pais_Id == this.state.model.pais_Id ? (
                                            <option value={pais.pais_Id} selected>
                                                {pais.nombre}
                                            </option>
                                        ) : (<option value={pais.pais_Id}>{pais.nombre}</option>))}
                                    </Input>
                                    <FormFeedback>
                                        {this.state.model.pais_Id == 0 ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label for="puerto_Id">
                                        <FormattedMessage id='Puerto' />
                                    </Label>
                                    <Input
                                        id="puerto_Id"
                                        name="puerto_Id"
                                        type="select"
                                        onChange={this.handleChange}
                                        value={this.state.model.puerto_Id}
                                        valid={this.getValidationValue(this.state.modelValidation.puerto_Id)}
                                        invalid={!this.getValidationValue(this.state.modelValidation.puerto_Id)}
                                    >
                                        <option value="0"></option>
                                        {this.state.puertos.map(puerto => puerto.puerto_Id == this.state.model.puerto_Id ? (
                                            <option value={puerto.puerto_Id} selected>
                                                {puerto.nombre}
                                            </option>
                                        ) : (<option value={puerto.puerto_Id}>{puerto.nombre}</option>))}
                                    </Input>
                                    <FormFeedback>
                                        {this.state.model.puerto_Id == 0 ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                    </FormFeedback>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </Row>
            </div>
        );
    }
    componentDidMount() {
        this.populateData();
    }
    async populateData() {
        this.setState({ loading: true, paises: await this.load_paises() },
            this.setState({ puertos: await this.load_puertos() })
        );
    }

    async load_paises() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/paises/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_puertos() {
        if (this.state.model.pais_Id != 0) {
            const token = await authService.getAccessToken();
            const response = await fetch('api/puertos?pais_Id=' + this.state.model.pais_Id, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            });
            return await response.json();
        }
        else {
            return [];
        }
    }
}